import { SearchData, TableHead } from "../../../../common/dataClass/Default"

/**搜索数据 */
class ProfitSearchData extends SearchData{
  constructor() {
    super()
    /**店铺 */
    this.store = ''
    /**国家站点 */
    this.countrySite = ''
  }
  /**搜索数据请求体 */
  get getSearchAxiosBody(){
    return {
      page: this.page,
      row: 10,
      saleStatus: 0,
      storeName: this.store? this.store : null,
      countryArea: this.countrySite? this.countrySite : null,
      textFilter: this.text? this.text : null
    }
  }
}

/**选品利润预算表头 */
class ProfitTableHead extends TableHead{
  constructor(name, prop, width) {
    super(name, prop, width)
  }
}

class ProductProfitNewModule{
  /**创建进度条数据 */
  static NEWPROGRESSARRAY(){
    let arr = [
      '新建在售商品利润核算信息',
      '选择店铺及商品',
      '输入商品数据',
      '点击利润计算',
      '保存计算数据',
      '上传汇总报告',
      '补充创建(如没对应listing)',
      '自动核算商品及店铺利润',
    ]
    return arr
  }
  /**在售商品与店铺利润核算表头 */
  static NEWTABLEHEAD(){
    let arr = [
      new ProfitTableHead('商品<br>图片', 'img', '80'),
      new ProfitTableHead('卖家SKU<br>(FNSKU)', 'name', '100'),
      new ProfitTableHead('商品型号<br>(ASIN)', 'img', '100'),
      new ProfitTableHead('商品名称', 'name', '100'),
      new ProfitTableHead('店铺名称<br>(国家站点)', 'img', '100'),
      new ProfitTableHead('计价<br>单位', 'unit', '50'),
      new ProfitTableHead('采购价格<br>(¥/单位)', 'unit', '80'),
      new ProfitTableHead('商品售价<br>(¥/单位)', 'unit', '80'),
      new ProfitTableHead('总成本与费用<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('商品净利润<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('总出资成本<br>(¥/单位)', 'unit', '80'),
      new ProfitTableHead('商品收汇<br>(¥/单位)', 'unit', '80'),
      new ProfitTableHead('当月坏品<br>退货量', 'unit', '80'),
      new ProfitTableHead('当月显示销量<br>(当月实际销量)', 'unit', '120'),
      new ProfitTableHead('当月销售额<br>(¥)', 'unit', '80'),
      new ProfitTableHead('当月净利润<br>(¥)', 'unit', '80'),
      new ProfitTableHead('当月销售<br>利润率(%)', 'unit', '80'),
      new ProfitTableHead('当月成本<br>利润率(%)', 'unit', '80'),
      new ProfitTableHead('当前<br>库存量', 'unit', '80'),
      new ProfitTableHead('库存价值<br>(¥)', 'unit', '80'),
      new ProfitTableHead('创建/更新时间<br>(更新状态)', 'unit', '100'),
      new ProfitTableHead('操作', 'operate', '80'),
    ]
    return arr
  }
  /**在售商品成本与费用表头 */
  static NEWCOSTTABLEHEAD(){
    let arr = [
      new ProfitTableHead('商品<br>图片', 'img', '80'),
      new ProfitTableHead('国家<br>站点', 'name', '80'),
      new ProfitTableHead('采购单价<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('国内运费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('国际运费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('进口关税<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('销售佣金<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('当地配送费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站内广告费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站内Deal<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('站内Coupon<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站外测评费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('站外引流费<br>(¥/单位)', 'unit', '120'),
      new ProfitTableHead('销售提成<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('管理提成<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('收汇损失<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('资金成本<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('坏品损耗<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('非坏品损耗<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('仓储费用<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('合仓费用<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('账户固定费<br>(¥/单位)', 'unit', '100'),
      new ProfitTableHead('总成本与费用<br>(¥/单位)', 'unit', '120'),
    ]
    return arr
  }
}

export { ProductProfitNewModule, ProfitSearchData }
